import React from 'react'

const SensorStatus = ({ sensors, permission, onRequestPermissions }) => {
  const sensorData = [
    {
      name: 'GPS',
      active: !!sensors.gps,
      description: 'Satellite positioning',
      icon: '📍',
      accuracy: sensors.gps?.accuracy ? `±${sensors.gps.accuracy.toFixed(1)}m` : 'Unknown'
    },
    {
      name: 'Accelerometer', 
      active: !!sensors.accelerometer,
      description: 'Movement and motion detection',
      icon: '📊',
      accuracy: 'High'
    },
    {
      name: 'Gyroscope',
      active: !!sensors.gyroscope,
      description: 'Device orientation and rotation',
      icon: '🔄',
      accuracy: 'High'
    },
    {
      name: 'WiFi Positioning',
      active: !!sensors.wifi,
      description: 'Indoor location accuracy',
      icon: '📶',
      accuracy: 'Medium'
    }
  ]

  const activeSensors = sensorData.filter(sensor => sensor.active).length

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Sensor Status</h3>
        <div className="text-sm text-gray-600">
          {activeSensors}/4 sensors active
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {sensorData.map((sensor, index) => (
          <div
            key={index}
            className={`p-3 border rounded-lg ${
              sensor.active 
                ? 'bg-green-50 border-green-200' 
                : 'bg-gray-50 border-gray-200'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="text-lg">{sensor.icon}</span>
                <div>
                  <h4 className="font-medium text-gray-900 text-sm">{sensor.name}</h4>
                  <p className="text-xs text-gray-600">{sensor.description}</p>
                </div>
              </div>
              <div className="text-right">
                <span className={`text-xs font-medium px-2 py-1 rounded ${
                  sensor.active 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {sensor.active ? 'Active' : 'Inactive'}
                </span>
                {sensor.active && sensor.accuracy && (
                  <p className="text-xs text-gray-600 mt-1">{sensor.accuracy}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {permission === 'denied' && (
        <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-3">
          <p className="text-sm text-yellow-800 mb-2">
            Sensor permissions denied. Enable for better accuracy.
          </p>
          <button
            onClick={onRequestPermissions}
            className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
          >
            Request Permissions
          </button>
        </div>
      )}
      {/* Live Sensor Data */}
      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <h4 className="text-sm font-medium text-gray-900 mb-2">Live Sensor Data</h4>
        <div className="grid grid-cols-2 gap-2 text-xs">
          {sensors.accelerometer && (
            <div>
              <span className="font-medium">Acceleration:</span>
              <div className="text-gray-600">
                X: {sensors.accelerometer.x.toFixed(2)}<br/>
                Y: {sensors.accelerometer.y.toFixed(2)}<br/>
                Z: {sensors.accelerometer.z.toFixed(2)}
              </div>
            </div>
          )}
          {sensors.gyroscope && (
            <div>
              <span className="font-medium">Orientation:</span>
              <div className="text-gray-600">
                α: {sensors.gyroscope.alpha.toFixed(1)}°<br/>
                β: {sensors.gyroscope.beta.toFixed(1)}°<br/>
                γ: {sensors.gyroscope.gamma.toFixed(1)}°
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SensorStatus